<template>
  <div class="pay-success-container">
    <w-navbar
            :icon="'iconchevron-left'"
            :nav_title="navTitleMap[origin]"
            @mobileLeftBtn="leftBtnClick"
            :isShowLeftIcon="!(origin === 'bJobHot' || origin === 'bJobTop' || origin === 'cPhotoBeauty' || origin === 'bHotAndTop' || origin === 'bJobRefresh')"
            v-show="iosOrAndroidShow"
    />
    <div class="main-con" v-if="origin === 'member'">
      <div :class="['pay-result', memberType === 'forever' ? 'isSuper' : '',]"></div>
      <div class="qrcode-container">
        <div class="qrcode">
          <img :src="memberData.image" alt="" />
        </div>
        <div class="text">
          <p>{{memberData.title}}</p>
          <p v-html="memberData.desc"></p>
        </div>
      </div>
      <div v-if="purchaseRecordData.state === 4" class="upgrade-member" @click="handleUpgradeMember">升级终身立享40元优惠</div>
      <!-- <div :class="['member-equity', isSuper ? 'member-equity-super' : '']"></div> -->
      <div class="member-equity-title">会员权益</div>
      <div class="member-equity flex">
        <div
          class="member-item flex" 
          v-for="(item, index) in memberships" 
          :key="`membership_item_${index}`"
          :class="{'opacity-text': item[memberType] === null}"
        >
          <img
            :src="item.icon"
            alt=""
            class="member-item-img"
          />
          <div class="desc-title">
            {{ `${item[memberType] || ''}${item.title}` }}
          </div>
          <div class="desc-description">
            {{ item.description }}
          </div>
        </div>
      </div>

      <div class="member-explain">
        <div class="title">会员说明</div>
        <p class="item">1. 从购买后立刻开始生效，享有超级会员所有特权</p>
        <p class="item">2. 使用期间可随时续费，有效期将直接累加</p>
        <p class="item">3. 会员过期后仅可使用免费功能</p>
        <p class="item">4. 可在我的订单中查看购买记录和时间</p>
        <p class="item">5. 最终解释权归超级简历所有，如有疑问，请联系在线客服</p>
      </div>
    </div>
    <div class="main-con" v-else-if="origin === 'mentor'">
      <div class="pay_success">
        <img src="https://files.wondercv.com/m/monter/monter_success1.png" alt="">
        <div class="title">
          购买成功
        </div>
        <div class="desc">
          稍后你会收到导师服务确认邮件
        </div>
        <div class="go_cvs" @click="goToCvs">我的简历</div>
      </div>
      <div class="monter_desc">
        <p>导师辅导说明：</p>
        <p>1. 导师服务由高盛、美世、Google、IBM、以及各大五百强公司的顶级导师提供简历辅导；</p>
        <p>2. 导师会针对你的问题进行回复，并且对于简历整体内容和求职方向提供点评，包括对每一段经历的必要性、排序、篇幅、重点、细节提供建议，并且对于一些错别字、格式错误、模糊描述会直接修改或提问；</p>
        <p>3. 导师不会帮你对简历的每一句话进行“精修”，全球人力资源顶级专家的专业角度不推荐求职者以外的人应该去动手去“写”求职者自己的简历。</p>
        <p style="margin-top: 18px">导师辅导流程：</p>
        <p>1. 下单后我们会审核你的简历，如遇到不符合要求的简历（比如缺失信息过多，和引导填写内容差异过大等）导师有可能会拒绝帮你进行修改辅导；</p>
        <p>2. 导师确认订单后会帮你创建一份新的导师辅导简历，并开始排上导师辅导日程；</p>
        <p>3. 一般导师反馈时间为3-5个工作日，加急订单为2个工作日内反馈，特急会1个工作日内反馈，导师提交会发送邮件/信息通知；</p>
        <p>4. 进入“我的简历”即可查看导师修改后的简历，左侧为导师的回复和建议，右侧为导师修改后的简历。</p>
      </div>
    </div>
    <div class="main-con" v-else-if="origin === 'bJobHot' || origin === 'bJobTop' || origin === 'cPhotoBeauty' || origin === 'bHotAndTop' || origin === 'bPhone' || origin === 'bJobRefresh'">
      <div class="b-job-pay">
        <img src="https://files.wondercv.com/m-vue/paid.png" alt="" class="paid">
        <p>支付成功</p>
        <p v-if="origin === 'bJobHot'">已成功发布热聊职位</p>
        <p v-else-if="origin === 'bJobTop'">已成功购买职位置顶服务</p>
        <p v-else-if="origin === 'cPhotoBeauty'">已成功购买超级简历证件照服务</p>
        <p v-else-if="origin === 'bPhone'">已成功购买查看电话次数</p>
        <p v-else-if="origin === 'bJobRefresh'">已成功购买职位刷新次数</p>
      </div>
    </div>
  </div>
</template>

<script>
  import WNavbar from '@/components/global/w-navbar';
  import { envMixin, loginMixin, WxMixin } from '@/assets/js/mixin/global';
  import { componentsMixin } from '../../assets/js/mixin/components'
  export default {
    name: "pay-success",
    components: {
      WNavbar
    },
    mixins: [ envMixin, loginMixin, WxMixin, componentsMixin],
    data() {
      return {
        isSuper: false,   // 是否是终身会员
        isSuperPlus: false,   // 是否是终身Plus会员
        isMonter: false,   // 是否是导师订单购买
        origin: null, // 支付类型
        activeOption: 0,
        navTitleMap: { // 导航栏标题
          mentor: '购买成功',
          member: '',
          bJobHot: '热聊职位',
          bJobTop: '置顶职位',
          cPhotoBeauty: '超级简历证件照'
        },
        memberType: 'month',
        hasRights: '1',
        memberships: [
          {
            title: "份简历",
            forever: '15',
            month: '5',
            year: '5',
            icon: 'https://static.wondercv.cn/cv_pc_vue/img/many_resume_active.12b0af24.png',
            description: "满足更多岗位投递",
          },
          {
            title: "次检查",
            forever: '无限',
            month: '100',
            year: '1500',
            icon: 'https://static.wondercv.cn/cv_pc_vue/img/detection.7fdaae03.png',
            description: "一键AI智能检查",
          },
          {
            title: "次简历翻译",
            forever: '无限',
            month: '10',
            year: '200',
            icon: 'https://static.wondercv.cn/cv_pc_vue/img/cv_transition_active.596434cc.png',
            description: "中英一键转换",
          },
          {
            title: "海量模板",
            forever: '',
            month: '',
            year: '',
            icon: 'https://static.wondercv.cn/cv_pc_vue/img/template_active.ce5f2861.png',
            description: "解锁所有专业模板",
          },
          {
            title: "专属社群",
            forever: '',
            month: '',
            year: '',
            icon: 'https://static.wondercv.cn/cv_pc_vue/img/job_active.a8b083ae.png',
            description: "会员求职社群",
          },
          {
            title: "次简历纠错",
            forever: '100',
            month: '10',
            year: '10',
            icon: 'https://static.wondercv.cn/cv_pc_vue/img/resume1_active.27c34434.png',
            description: "语义纠错完善细节",
          },
          {
            title: "次证件照制作",
            forever: '5',
            month: '1',
            year: '1',
            icon: 'https://static.wondercv.cn/cv_pc_vue/img/image_active.e01a8276.png',
            description: "极速制作一键使用",
          },
          {
            title: "365天简历恢复",
            forever: '',
            month: null,
            year: null,
            icon: 'https://static.wondercv.cn/cv_pc_vue/img/resume_repair.50154749.png',
            description: "避免误删信息丢失",
          },
          {
            title: "专属客服",
            forever: '',
            month: null,
            year: null,
            icon: 'https://logo.wondercv.com/banners/PT8AP8Fkl2ZpUZE.png',
            description: "问题反馈优先解决",
          },
        ],
        purchaseRecordData: {}
      }
    },
    computed: {
      memberData() {
        switch(this.memberType) {
          case 'forever':
            return {
              image: 'https://logo.wondercv.com/banners/18yfCgmWeEVzjXD.png',
              title: '扫码添加小助手',
              desc: '即可进入会员专享求职社群<br />领取2周Offer秘籍！'
            }
          case 'month':
            return {
              image: this.hasRights === '1' ? 'https://logo.wondercv.com/banners/h8fkB1uFx1lXeXZ.png' : 'https://logo.wondercv.com/banners/XX7Vy58i5zJ1Qb0.png',
              title: '扫码添加小助手',
              desc: this.hasRights === '1' ? '即可进入会员专享求职社群<br />领取2周Offer秘籍！' : '即可进入会员专享求职社群'
            }
          case 'year':
            return {
              image: this.hasRights === '1' ? 'https://logo.wondercv.com/banners/1A0ugYHZZmFGhjh.png' : 'https://logo.wondercv.com/banners/N4MdikAVxEEM1BJ.png',
              title: '扫码添加小助手',
              desc: this.hasRights === '1' ? '即可进入会员专享求职社群<br />领取2周Offer秘籍！' : '即可进入会员专享求职社群'
            }
        }
      }
    },
    mounted() {
      this.isSuperPlus = this.$db.ls.get('member_isSuperPlus')
      this.isSuper = this.$db.ls.get('member_isSuper') || this.isSuperPlus
      this.getPurchaseRecordData()
      // 有参数的为会员购买
      let member = this.$route.query.origin
      if (!member) {
        this.isMonter = true
      }
      let origin = this.$route.query.origin
      this.memberType = this.$route.query.memberType || ''
      this.hasRights = this.$route.query.hasRights || '2'
      this.activeOption = Number(this.$route.query.activeOption)
      this.origin = origin
    },
    methods: {
      // 返回会员购买页
      leftBtnClick() {
        this.$router.push({path: '/buy/member/order'})
      },
      goToCvs() {
        this.$router.push('/cvs')
      },
      handleUpgradeMember() {
        this.$router.push('/buy/member/order')
      },
      async getPurchaseRecordData() {
        try {
          const { code, data } = await this.$api.user.getPurchaseRecordData();
          if (code === 1000) {
            this.purchaseRecordData = data;
          }
        } catch (error) {
          console.log(error)
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .pay-success-container{
    width: 100vw;
    height: 100vh;
    .main-con{
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 68px;
      .pay-result{
        width: 260px;
        height: 78px;
        background: url("https://files.wondercv.com/m/buyMember/pay_success_normal.png") no-repeat;
        background-size: 100% 100%;
      }
      .isSuper{
        background: url("https://files.wondercv.com/m/buyMember/pay_success_super.png") no-repeat;
        background-size: 100% 100%;
      }
      .isSuperPlus{
        height: 68px;
        background: url("https://files.wondercv.com/m/buyMember/pay_success_super_plus.png") no-repeat;
        background-size: 100% 100%;
      }
      .qrcode-container{
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        margin-top: 16px;
        justify-content: center;
        .qrcode{
          width: 191px;
          height: 191px;
          /*background: url("https://files.wondercv.com/pc/members/other_member.png") no-repeat;*/
          /*background-size: 100% 100%;*/
          img{
            width: 100%;
            height: 100%;
          }
        }
        /*.qrcode-super{*/
        /*  background: url("https://files.wondercv.com/pc/members/life_member.png") no-repeat;*/
        /*  background-size: 100% 100%;*/
        /*}*/
        .text{
          width: 100%;
          margin-top: 16px;
          line-height: 22px;
          font-size: 16px;
          color: #404040;
          p{
            text-align: center;
          }
        }
      }
      .upgrade-member {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80%;
        font-size: 16px;
        color: #fff;
        background: linear-gradient(90deg, #ff9c62, #ff6030);
        font-weight: 700;
        border-radius: 24px;
        height: 46px;
        margin-top: 24px;
      }
      .member-equity-title{
        margin-top: 24px;
        font-size: 16px;
        color: #404040;
        margin-bottom: 16px;
        text-align: left;
        width: 327px;
      }
      .member-equity{
        width: 327px;
        //height: 268px;
        flex-wrap: wrap;
        /*background: url("https://files.wondercv.com/m/buyMember/member_normal1.png") no-repeat;*/
        /*background-size: 100% 100%;*/
        //background: url("https://files.wondercv.com/m/buyMember/member_super2.png") no-repeat;
        //background-size: 100% 100%;
        .member-item {
          width: 33%;
          flex-direction: column;
          align-items: center;
          position: relative;
          .member-item-img {
            width: 48px;
            height: 48px;
            object-fit: contain;
          }
          .tips {
            width: 28px;
            height: 12px;
            position: absolute;
            top: 12px;
            right: 10px;
          }
          .desc-title {
            color: #404040;
            font-size: 14px;
          }
          .desc-description {
            color: #9C9C9C;
            font-size: 10px;
            margin-top: 5px;
          }
        }
        .opacity-text {
          opacity: 0.5;
        }
      }
      // .member-equity{
      //   width: 327px;
      //   height: 208px;
      //   margin-top: 24px;
      //   background: url("https://files.wondercv.com/m/buyMember/member_normal1.png") no-repeat;
      //   background-size: 100% 100%;
      // }
      // .member-equity-super{
      //   background: url("https://files.wondercv.com/m/buyMember/member_super1.png") no-repeat;
      //   background-size: 100% 100%;
      // }
      .member-explain{
        width: 100%;
        height: auto;
        margin-top: 24px;
        padding: 0 24px 20px;
        font-size: 12px;
        color: #909090;
        .title{
          font-size: 16px;
          color: #404040;
          margin-bottom: 16px;
        }
        .item{
          line-height: 24px;
        }
      }
      .pay_success{
        width: 100%;
        padding: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
          width: 41px;
          height: 41px;
          object-fit: cover;
        }
        .title{
          margin-top: 14px;
          font-size: 18px;
          color: #404040;
          line-height: 25px;
          font-weight: 600;
        }
        .desc{
          margin-top: 6px;
          font-size: 14px;
          color: #666666;
          line-height: 20px;
        }
        .go_cvs{
          width: 263px;
          height: 44px;
          margin-top: 32px;
          background-color: #ff4f4c;
          border-radius: 4px;
          color: #fff;
          line-height: 44px;
          font-size: 16px;
          text-align: center;
        }
      }
      .monter_desc{
        color: #9c9c9c;
        font-size: 14px;
        line-height: 20px;
        padding: 0 24px 24px;
      }

      .b-job-pay {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 90px;

        .paid {
          width: 41px;
          height: 41px;
          margin-bottom: 14px;
        }

        p:first-of-type {
          font-size: 18px;
          font-weight: 600;
          color: #404040;
          line-height: 25px;
          margin-bottom: 6px;
        }

        p:last-of-type {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
        }
      }
    }
  }
  /*.img{*/
  /*  width: 210px;*/
  /*  height: 152px;*/
  /*  margin: 64px 82px 0 82px;*/
  /*}*/
</style>